import { GuardFunction } from 'react-router-guards';
import { getItemInStorage } from '../../hooks/useLocalStorage';
import { montarCaminho } from '..';

export const checkUserLogged: GuardFunction = (to, from, next) => {
  const accessToken = getItemInStorage('accessToken');
  const refreshToken = getItemInStorage('refreshToken');

  if (to.meta.auth) {
    if (!accessToken && !refreshToken) {
      next.redirect(montarCaminho('/'));
    } else {
      next();
    }
  } else {
    next();
  }
};
